import React from "react";
import { IconButton, Tooltip, Zoom } from "@material-ui/core";
import { Input } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

export const ExcusableDetailButton = props => {
  const history = useHistory();
  const path = props?.path ?? props?.resource ?? "";
  const onClick = e => {
    e.stopPropagation();
    props?.onClick?.(props.record);
    if (props.onClickDisabled != true) {
      const win: any = window.open(
        `#/${path}/${props?.record?.id ?? ""}?requestType=${props?.record?.requestOrderType}`,
        "_blank"
      );
      win.focus();
    }
  };
  return (
    <IconButton {...props} style={{ width: 40 }} onClick={onClick}>
      <Tooltip TransitionComponent={Zoom} title="Detail">
        <Input />
      </Tooltip>
    </IconButton>
  );
};
export default ExcusableDetailButton;
